export enum Pages {
  CONTACT = 'contact',
  STATS = 'stats',
  HOME = 'home',
  DISCOVER = 'discover',
  SETTINGS = 'settings',
  EXHIBITS = 'exhibits',
}

// Identifiers of a page for the settings block API
export enum BlockPages {
  HOME = 'home',
  DISCOVER = 'discover',
  EXHIBIT = 'player',
}
